export default __webpack_public_path__ + "static/1-browser-support-328c2df60a6d8f59becedb36b7d89cb5.png";